import { FormsActions as Actions } from "./activityForms.types";
import {
  SET_PREVIEWACTIVITYFORM,
  SET_SELECTEDACTIVITYFORM,
  SET_ACTIVITYFORM_CHANGES
} from "./activityForms.actions";

const initialState = {
  selectedActivityForms: null,
  previewActivityForms: null,
  activityFormsChanges: null
};

const reducer = (state = initialState, action: Actions) => {
  switch (action.type) {
    case SET_SELECTEDACTIVITYFORM:
      return { ...state, selectedActivityForms: action.payload };
    case SET_PREVIEWACTIVITYFORM:
      return { ...state, previewActivityForms: action.payload };
    case SET_ACTIVITYFORM_CHANGES:
      return { ...state, activityFormsChanges: action.payload };
    default:
      return state;
  }
};

export default reducer;
